import React from 'react';
import { MainTabBar as MainTabBarBase } from '@sweetgreen/garnish';

import { useChallengesAndRewards } from '@order/ChallengesAndRewards';
import { useFeatureFlag } from '@order/LaunchDarkly';

import type { MainTabName } from '../../navigation/AppNavigation.props';

// Wrapper around garnish's MainTabBar.
// Adds challenges feature flag check + badge.
export const MainTabBar = (props: MainTabBarProps) => {
  const { hasUnseenChallenges } = useChallengesAndRewards();
  const isChallengesEnabled = useFeatureFlag('OPS-challenges-enabled', {
    listenForChanges: true,
  });

  const hiddenTabs: MainTabNames = !isChallengesEnabled ? ['LoyaltyTab'] : [];
  const tabsDisplayingBadge: MainTabNames = hasUnseenChallenges
    ? ['LoyaltyTab']
    : [];

  return (
    <MainTabBarBase
      hiddenTabs={hiddenTabs}
      tabsDisplayingBadge={tabsDisplayingBadge}
      maxFontSizeMultiplier={1.1}
      {...props}
    />
  );
};

type MainTabNames = readonly MainTabName[];

type MainTabBarProps = Omit<
  React.ComponentProps<typeof MainTabBarBase>,
  'hiddenTabs' | 'tabsDisplayingBadge'
>;
